import { Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import HomePage from './pages/Home';
import NetworkPage from './pages/Network';
import DexPage from './pages/Dex';
import DefiPage from './pages/Defi';

export default function App() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/network" element={<NetworkPage />} />
        <Route path="/defi" element={<DefiPage />} />
        <Route path="/dex" element={<DexPage />} />
      </Routes>
    </Layout>
  );
}
